import React from "react";
import { useNavigate } from "react-router-dom";

export default function PrivacyPage() {
  const navigate = useNavigate();
  return (
    <div style={{ fontFamily: "'DM Sans', sans-serif", background: "#FAFAFA", color: "#0D1B3E", minHeight: "100vh" }}>
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        .legal-content h3 { font-family: 'Playfair Display', serif; font-size: 1.375rem; font-weight: 700; margin-top: 36px; margin-bottom: 14px; color: #0D1B3E; }
        .legal-content p { color: #4B5563; font-size: 1rem; line-height: 1.8; margin-bottom: 16px; }
        .legal-content ul { margin: 8px 0 16px 0; padding-left: 24px; }
        .legal-content li { color: #4B5563; font-size: 1rem; line-height: 1.7; margin-bottom: 6px; }
        .legal-content a { color: #1A3CE8; text-decoration: underline; }
      `}</style>

      <nav style={{ background: "white", borderBottom: "1px solid #F3F4F6", padding: "16px 5%", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <button onClick={() => navigate("/")} style={{ background: "transparent", border: "none", cursor: "pointer", fontFamily: "'Playfair Display', serif", fontSize: "1.5rem", fontWeight: 700, color: "#0D1B3E" }}>← Mouna</button>
        <button onClick={() => navigate("/login")} style={{ background: "#1A3CE8", color: "white", border: "none", borderRadius: "100px", padding: "10px 24px", fontWeight: 700, fontSize: "0.875rem", cursor: "pointer" }}>Get Started</button>
      </nav>

      <div style={{ background: "linear-gradient(135deg, #0D1B3E, #1A3CE8)", padding: "64px 5%", textAlign: "center", color: "white" }}>
        <div style={{ maxWidth: "720px", margin: "0 auto" }}>
          <div style={{ fontSize: "0.7rem", fontWeight: 700, color: "#F5A623", letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: "20px" }}>LEGAL</div>
          <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(2.25rem, 5vw, 3.5rem)", fontWeight: 700, marginBottom: "16px", lineHeight: 1.15 }}>Privacy Policy</h1>
          <p style={{ color: "rgba(255,255,255,0.75)", fontSize: "1rem", lineHeight: 1.7 }}>Last updated: May 2026</p>
        </div>
      </div>

      <div style={{ padding: "60px 5% 80px", background: "white" }}>
        <div className="legal-content" style={{ maxWidth: "780px", margin: "0 auto" }}>
          <p>Mouna collects the minimum information needed to operate the marketplace. We don't sell your data. We don't share it with advertisers. We use it to help you book home services in Houston, and that's about it.</p>

          <h3>What we collect</h3>
          <p>When you create an account or use Mouna, we collect:</p>
          <ul>
            <li>Your name, email, and phone number (so pros can contact you about bookings)</li>
            <li>Your service address (so pros know where to come)</li>
            <li>Booking history, messages with pros, and any reviews you leave</li>
            <li>Standard web logs (IP address, browser type, pages viewed) for security and analytics</li>
          </ul>
          <p>When pros sign up, we additionally collect business name, service category, and the same contact basics.</p>

          <h3>How we use your information</h3>
          <p>We use this information to:</p>
          <ul>
            <li>Operate the marketplace and process your bookings</li>
            <li>Help you and your pro communicate about a job</li>
            <li>Send transactional emails (booking confirmations, password resets, account verification)</li>
            <li>Improve the product over time</li>
            <li>Detect fraud or abuse and keep accounts secure</li>
          </ul>
          <p>We don't use your data to target you with ads or sell it to third parties.</p>

          <h3>Who else sees it</h3>
          <p>Your pro sees the information necessary to fulfill your booking — typically name, contact info, service address, and the job details you provided.</p>
          <p>Mouna runs on Amazon Web Services. AWS processes data on our behalf to host the platform. We use Amazon Cognito for authentication, Amazon SES for sending email, and Amazon DynamoDB as our database. AWS is bound by their data processing agreement and doesn't use your data for their own purposes.</p>
          <p>We may share information if required by law or to enforce these terms. We'll push back on overly broad requests where we can.</p>

          <h3>Cookies and local storage</h3>
          <p>We use a session cookie to keep you signed in. We don't use tracking cookies or advertising pixels.</p>

          <h3>Your rights</h3>
          <p>You can:</p>
          <ul>
            <li>Access the personal information we hold about you</li>
            <li>Correct anything that's inaccurate</li>
            <li>Delete your account and the associated data (subject to legitimate business records we may need to keep, such as for tax or fraud-prevention purposes)</li>
          </ul>
          <p>To exercise any of these rights, email <a href="mailto:support@mounahub.com">support@mounahub.com</a>.</p>

          <h3>Children</h3>
          <p>Mouna is intended for adults aged 18 and over. We don't knowingly collect personal information from anyone under 18. If you believe a minor has signed up, let us know and we'll remove the account.</p>

          <h3>Changes to this policy</h3>
          <p>We may update this policy as our practices evolve. Material changes will be noted at the top of this page. Continued use of Mouna after changes means you accept the updated policy.</p>

          <h3>Contact</h3>
          <p>Privacy questions? Email us at <a href="mailto:support@mounahub.com">support@mounahub.com</a>.</p>
        </div>
      </div>

      <div style={{ background: "#080F20", padding: "32px 5%", textAlign: "center", color: "rgba(255,255,255,0.4)", fontSize: "0.75rem" }}>© 2026 Mouna. All rights reserved.</div>
    </div>
  );
}